/* Бухгалтерія (BAS) — /finance/bas and BAS blocks on ФОП, supplier and invoice cards. Kept apart from uk.ts/en.ts to keep merges small. */
export const basUk = {
  'nav.bas': 'Бухгалтерія (BAS)',
  'perm.bas.hr': 'Працівники з BAS: дати прийому/звільнення, посади (без зарплат)',
  'bas.title': 'Бухгалтерія (BAS)',
  'bas.subtitle': 'Дані з BAS лише для читання: податки й зарплата по ФОПах, банк і каса, зв’язки з ФОПами й постачальниками.',
  'bas.tabStatus': 'Податки й зарплата',
  'bas.tabDocs': 'Банк і каса',
  'bas.tabCashflow': 'Доходи й витрати',
  'bas.tabOrgs': 'Організації ↔ ФОПи',
  'bas.tabCounterparties': 'Контрагенти ↔ постачальники',
  'bas.tabEmployees': 'Працівники',
  'bas.tabSources': 'Джерела',
  'bas.noSources': 'Джерела BAS ще не підключені',
  'bas.noSourcesHint': 'Додайте базу BAS на вкладці «Джерела» (адреса OData, користувач, пароль) і увімкніть конектор BAS в Адмін → Конектори. Дані з’являться після першої синхронізації.',
  'bas.source': 'Джерело',
  'bas.anySource': 'Усі джерела',
  'bas.month': 'Місяць',
  'bas.prevMonth': 'Попередній місяць',
  'bas.nextMonth': 'Наступний місяць',
  'bas.org': 'Організація',
  'bas.fop': 'ФОП',
  'bas.employeesCount': 'Працівників',
  'bas.col.ep': 'ЄП',
  'bas.col.esv': 'ЄСВ',
  'bas.col.pdfo': 'ПДФО + ВЗ',
  'bas.col.payroll_accrued': 'Зарплату нараховано',
  'bas.col.payroll_paid': 'Зарплату виплачено',
  'bas.cell.ok': 'Так',
  'bas.cell.pending': 'Очікується',
  'bas.cell.overdue': 'Прострочено',
  'bas.cell.none': '—',
  'bas.due': 'до {date}',
  'bas.deadlines': 'Терміни: зарплата до {pay}-го наступного місяця, ЄСВ/ПДФО до {tax}-го, ЄП (1–2 група) до {ep}-го числа місяця.',
  'bas.normsToConfirm': 'Терміни ще не підтверджені бухгалтером — перевірте їх у «Процеси → Норми».',
  'bas.overdueOrgs': 'Прострочення: {n}',
  'bas.unlinkedOrgs': 'Організацій без ФОПа: {n} — зв’яжіть їх на вкладці «Організації ↔ ФОПи».',
  'bas.matrixEmpty': 'Немає організацій з BAS',
  'bas.matrixEmptyHint': 'Організації з’являться після синхронізації джерел BAS.',
  'bas.warn.payroll_not_accrued': 'Зарплату не нараховано',
  'bas.warn.payroll_not_paid': 'Зарплату не виплачено',
  'bas.warn.esv_not_paid': 'ЄСВ не сплачено',
  'bas.warn.pdfo_not_paid': 'ПДФО не сплачено',
  'bas.warn.ep_not_paid': 'ЄП не сплачено',
  'bas.kind.bank_out': 'Списання з рахунку',
  'bas.kind.bank_in': 'Надходження на рахунок',
  'bas.kind.cash_out': 'Видатковий касовий ордер',
  'bas.kind.cash_in': 'Прибутковий касовий ордер',
  'bas.kind.out': 'Усі витрати',
  'bas.kind.in': 'Усі надходження',
  'bas.anyKind': 'Будь-який вид',
  'bas.anyCategory': 'Будь-яка категорія',
  'bas.anyFop': 'Усі ФОПи',
  'bas.cat.supplier_payment': 'Оплата постачальнику',
  'bas.cat.customer_payment': 'Оплата від покупця',
  'bas.cat.tax': 'Податок',
  'bas.cat.payroll': 'Зарплата',
  'bas.cat.refund': 'Повернення',
  'bas.cat.transfer': 'Переказ між рахунками',
  'bas.cat.cash': 'Готівка',
  'bas.cat.social': 'Соцстрах',
  'bas.cat.other': 'Інше',
  'bas.tax.ep': 'ЄП',
  'bas.tax.esv': 'ЄСВ',
  'bas.tax.pdfo': 'ПДФО',
  'bas.tax.military': 'Військовий збір',
  'bas.tax.other': 'Інший податок',
  'bas.docsSearch': 'Номер, контрагент, призначення',
  'bas.docsEmpty': 'Документів не знайдено',
  'bas.docsEmptyHint': 'Змініть фільтри або дочекайтеся синхронізації BAS.',
  'bas.number': 'Номер',
  'bas.date': 'Дата',
  'bas.counterparty': 'Контрагент',
  'bas.purpose': 'Призначення',
  'bas.amount': 'Сума',
  'bas.notPosted': 'не проведено',
  'bas.sumOut': 'Витрати',
  'bas.sumIn': 'Надходження',
  'bas.found': 'Знайдено: {n}',
  'bas.personalHidden': 'сума не зберігається (виплата одній особі)',
  'bas.more': 'Показати ще',
  'bas.incomes': 'Надходження по ФОПах',
  'bas.expenses': 'Витрати за статтями',
  'bas.total': 'Разом',
  'bas.cashflowEmpty': 'За ці місяці проведених документів немає',
  'bas.linkFop': 'ФОП у Bridge',
  'bas.chooseFop': 'Оберіть ФОП',
  'bas.ignored': 'Не наш ФОП',
  'bas.ignore': 'Не наш',
  'bas.unlink': 'Скинути',
  'bas.link': 'Зв’язати',
  'bas.suggested': 'Пропозиція: {name}',
  'bas.reason.tax_id': 'той самий ІПН',
  'bas.reason.edrpou': 'той самий ЄДРПОУ',
  'bas.reason.name': 'назва',
  'bas.reason.surname': 'прізвище',
  'bas.accept': 'Прийняти',
  'bas.autoLink': 'Автозв’язати',
  'bas.autoLinked': 'Зв’язано: {n}',
  'bas.auto': 'авто',
  'bas.legal': 'юр. особа',
  'bas.person': 'ФОП',
  'bas.bankAccounts': 'Рахунків',
  'bas.orgsEmpty': 'Організацій з BAS ще немає',
  'bas.supplier': 'Постачальник',
  'bas.chooseSupplier': 'Оберіть постачальника',
  'bas.createSupplier': 'Створити картку',
  'bas.supplierCreated': 'Картку постачальника створено',
  'bas.onlySuppliers': 'Лише постачальники',
  'bas.onlyUnlinked': 'Лише незв’язані',
  'bas.contracts': 'Договорів',
  'bas.terms': 'Відстрочка',
  'bas.termsDays': '{n} дн',
  'bas.paid12m': 'Оплачено за 12 міс',
  'bas.cpEmpty': 'Контрагентів не знайдено',
  'bas.notSupplier': 'Не постачальник',
  'bas.position': 'Посада',
  'bas.department': 'Підрозділ',
  'bas.hired': 'Прийнято',
  'bas.left': 'Звільнено',
  'bas.includeLeft': 'Показати звільнених',
  'bas.enoteEmployee': 'Enote',
  'bas.bridgeUser': 'Користувач Bridge',
  'bas.employeesEmpty': 'Працівників не знайдено',
  'bas.employeesHint': 'Дані з наказів BAS про прийом і звільнення. Зарплати тут не показуються.',
  'bas.addSource': 'Додати джерело',
  'bas.editSource': 'Джерело BAS',
  'bas.sourceKey': 'Ключ',
  'bas.sourceKeyHint': 'Латиницею, наприклад tov або fop. Змінити потім не можна.',
  'bas.sourceName': 'Назва',
  'bas.baseUrl': 'Адреса OData',
  'bas.username': 'Користувач OData',
  'bas.password': 'Пароль',
  'bas.passwordKeep': 'Залиште порожнім, щоб не змінювати.',
  'bas.passwordSet': 'Пароль збережено',
  'bas.passwordNotSet': 'Пароль не задано',
  'bas.skipTls': 'Не перевіряти TLS-сертифікат (самопідписаний)',
  'bas.enabled': 'Увімкнено',
  'bas.test': 'Перевірити',
  'bas.testOk': 'Підключення працює',
  'bas.testFail': 'Перевірка не пройшла — дивіться кроки',
  'bas.sourceSaved': 'Джерело збережено',
  'bas.sourceDeleted': 'Джерело видалено',
  'bas.deleteConfirm': 'Видалити джерело «{name}» разом з усіма його даними в Bridge?',
  'bas.sourcesHint': 'Кожна база BAS — окреме джерело. Користувачу потрібні права «Удаленный доступ: стандартный интерфейс OData» лише на читання.',
  'bas.rows': 'Записів: {n}',
  'bas.fopBlock': 'BAS',
  'bas.fopNotLinked': 'Цей ФОП ще не зв’язаний з організацією в BAS.',
  'bas.lastTaxes': 'Останні податки',
  'bas.mainAccount': 'основний',
  'bas.months': 'Податки й зарплата',
  'bas.supplierBlock': 'BAS: договори й оплати',
  'bas.supplierNotLinked': 'Постачальник не зв’язаний з контрагентом BAS — зв’яжіть у «Фінанси → Бухгалтерія (BAS)».',
  'bas.suggestedTerms': 'У договорі BAS відстрочка {n} дн (у картці {cur}).',
  'bas.applyTerms': 'Застосувати',
  'bas.termsApplied': 'Відстрочку оновлено',
  'bas.payments': 'Оплати',
  'bas.matchesTitle': 'Оплати з BAS',
  'bas.matchesEmpty': 'У BAS не знайдено оплат цьому постачальнику поруч із датою накладної.',
  'bas.exact': 'сума збігається',
  'bas.diff': 'різниця {amount}',
  'bas.confirmPaid': 'Підтвердити оплату',
  'bas.confirmedPaid': 'Накладну позначено оплаченою',
}

export const basEn: { [K in keyof typeof basUk]?: string } = {
  'nav.bas': 'Accounting (BAS)',
  'perm.bas.hr': 'Employees from BAS: hire/dismissal dates, positions (no salaries)',
  'bas.title': 'Accounting (BAS)',
  'bas.subtitle': 'Read-only BAS data: taxes and payroll per ФОП, bank and cash, links to ФОПи and suppliers.',
  'bas.tabStatus': 'Taxes & payroll',
  'bas.tabDocs': 'Bank & cash',
  'bas.tabCashflow': 'Incomes & expenses',
  'bas.tabOrgs': 'Organizations ↔ ФОПи',
  'bas.tabCounterparties': 'Counterparties ↔ suppliers',
  'bas.tabEmployees': 'Employees',
  'bas.tabSources': 'Sources',
  'bas.noSources': 'No BAS sources connected yet',
  'bas.noSourcesHint': 'Add a BAS database on the «Sources» tab (OData URL, user, password) and enable the BAS connector in Admin → Connectors. Data appears after the first sync.',
  'bas.source': 'Source',
  'bas.anySource': 'All sources',
  'bas.month': 'Month',
  'bas.prevMonth': 'Previous month',
  'bas.nextMonth': 'Next month',
  'bas.org': 'Organization',
  'bas.fop': 'ФОП',
  'bas.employeesCount': 'Employees',
  'bas.col.ep': 'Single tax',
  'bas.col.esv': 'ЄСВ',
  'bas.col.pdfo': 'PIT + military levy',
  'bas.col.payroll_accrued': 'Payroll accrued',
  'bas.col.payroll_paid': 'Payroll paid',
  'bas.cell.ok': 'Yes',
  'bas.cell.pending': 'Pending',
  'bas.cell.overdue': 'Overdue',
  'bas.cell.none': '—',
  'bas.due': 'by {date}',
  'bas.deadlines': 'Deadlines: payroll by day {pay} of the next month, ЄСВ/PIT by day {tax}, single tax (groups 1–2) by day {ep} of the month.',
  'bas.normsToConfirm': 'Deadlines are not confirmed by the accountant yet — check them in Processes → Norms.',
  'bas.overdueOrgs': 'Overdue: {n}',
  'bas.unlinkedOrgs': 'Organizations without a ФОП: {n} — link them on «Organizations ↔ ФОПи».',
  'bas.matrixEmpty': 'No organizations from BAS',
  'bas.matrixEmptyHint': 'Organizations appear after the BAS sources are synced.',
  'bas.warn.payroll_not_accrued': 'Payroll not accrued',
  'bas.warn.payroll_not_paid': 'Payroll not paid',
  'bas.warn.esv_not_paid': 'ЄСВ not paid',
  'bas.warn.pdfo_not_paid': 'PIT not paid',
  'bas.warn.ep_not_paid': 'Single tax not paid',
  'bas.kind.bank_out': 'Bank outflow',
  'bas.kind.bank_in': 'Bank inflow',
  'bas.kind.cash_out': 'Cash outflow',
  'bas.kind.cash_in': 'Cash inflow',
  'bas.kind.out': 'All outflows',
  'bas.kind.in': 'All inflows',
  'bas.anyKind': 'Any kind',
  'bas.anyCategory': 'Any category',
  'bas.anyFop': 'All ФОПи',
  'bas.cat.supplier_payment': 'Supplier payment',
  'bas.cat.customer_payment': 'Customer payment',
  'bas.cat.tax': 'Tax',
  'bas.cat.payroll': 'Payroll',
  'bas.cat.refund': 'Refund',
  'bas.cat.transfer': 'Own transfer',
  'bas.cat.cash': 'Cash',
  'bas.cat.social': 'Social insurance',
  'bas.cat.other': 'Other',
  'bas.tax.ep': 'Single tax',
  'bas.tax.esv': 'ЄСВ',
  'bas.tax.pdfo': 'PIT',
  'bas.tax.military': 'Military levy',
  'bas.tax.other': 'Other tax',
  'bas.docsSearch': 'Number, counterparty, purpose',
  'bas.docsEmpty': 'No documents found',
  'bas.docsEmptyHint': 'Change the filters or wait for the BAS sync.',
  'bas.number': 'Number',
  'bas.date': 'Date',
  'bas.counterparty': 'Counterparty',
  'bas.purpose': 'Purpose',
  'bas.amount': 'Amount',
  'bas.notPosted': 'not posted',
  'bas.sumOut': 'Outflows',
  'bas.sumIn': 'Inflows',
  'bas.found': 'Found: {n}',
  'bas.personalHidden': 'amount not stored (payment to one person)',
  'bas.more': 'Show more',
  'bas.incomes': 'Inflows per ФОП',
  'bas.expenses': 'Expenses by item',
  'bas.total': 'Total',
  'bas.cashflowEmpty': 'No posted documents in these months',
  'bas.linkFop': 'Bridge ФОП',
  'bas.chooseFop': 'Choose a ФОП',
  'bas.ignored': 'Not ours',
  'bas.ignore': 'Not ours',
  'bas.unlink': 'Clear',
  'bas.link': 'Link',
  'bas.suggested': 'Suggested: {name}',
  'bas.reason.tax_id': 'same tax number',
  'bas.reason.edrpou': 'same ЄДРПОУ',
  'bas.reason.name': 'name',
  'bas.reason.surname': 'surname',
  'bas.accept': 'Accept',
  'bas.autoLink': 'Auto-link',
  'bas.autoLinked': 'Linked: {n}',
  'bas.auto': 'auto',
  'bas.legal': 'company',
  'bas.person': 'ФОП',
  'bas.bankAccounts': 'Accounts',
  'bas.orgsEmpty': 'No organizations from BAS yet',
  'bas.supplier': 'Supplier',
  'bas.chooseSupplier': 'Choose a supplier',
  'bas.createSupplier': 'Create card',
  'bas.supplierCreated': 'Supplier card created',
  'bas.onlySuppliers': 'Suppliers only',
  'bas.onlyUnlinked': 'Unlinked only',
  'bas.contracts': 'Contracts',
  'bas.terms': 'Payment terms',
  'bas.termsDays': '{n} d',
  'bas.paid12m': 'Paid in 12 months',
  'bas.cpEmpty': 'No counterparties found',
  'bas.notSupplier': 'Not a supplier',
  'bas.position': 'Position',
  'bas.department': 'Department',
  'bas.hired': 'Hired',
  'bas.left': 'Left',
  'bas.includeLeft': 'Show dismissed',
  'bas.enoteEmployee': 'Enote',
  'bas.bridgeUser': 'Bridge user',
  'bas.employeesEmpty': 'No employees found',
  'bas.employeesHint': 'From BAS hire and dismissal orders. Salaries are never shown here.',
  'bas.addSource': 'Add source',
  'bas.editSource': 'BAS source',
  'bas.sourceKey': 'Key',
  'bas.sourceKeyHint': 'Latin letters, e.g. tov or fop. Cannot be changed later.',
  'bas.sourceName': 'Name',
  'bas.baseUrl': 'OData URL',
  'bas.username': 'OData user',
  'bas.password': 'Password',
  'bas.passwordKeep': 'Leave empty to keep it.',
  'bas.passwordSet': 'Password saved',
  'bas.passwordNotSet': 'No password',
  'bas.skipTls': 'Do not verify the TLS certificate (self-signed)',
  'bas.enabled': 'Enabled',
  'bas.test': 'Test',
  'bas.testOk': 'Connection works',
  'bas.testFail': 'Test failed — see the steps',
  'bas.sourceSaved': 'Source saved',
  'bas.sourceDeleted': 'Source deleted',
  'bas.deleteConfirm': 'Delete the source «{name}» with all its data in the Bridge?',
  'bas.sourcesHint': 'Each BAS database is a separate source. The user needs read-only «Remote access: standard OData interface» rights.',
  'bas.rows': 'Rows: {n}',
  'bas.fopBlock': 'BAS',
  'bas.fopNotLinked': 'This ФОП is not linked to a BAS organization yet.',
  'bas.lastTaxes': 'Latest taxes',
  'bas.mainAccount': 'main',
  'bas.months': 'Taxes & payroll',
  'bas.supplierBlock': 'BAS: contracts and payments',
  'bas.supplierNotLinked': 'The supplier is not linked to a BAS counterparty — link it in Finance → Accounting (BAS).',
  'bas.suggestedTerms': 'The BAS contract has {n}-day terms (card: {cur}).',
  'bas.applyTerms': 'Apply',
  'bas.termsApplied': 'Payment terms updated',
  'bas.payments': 'Payments',
  'bas.matchesTitle': 'Payments in BAS',
  'bas.matchesEmpty': 'No BAS payments to this supplier near the invoice date.',
  'bas.exact': 'same amount',
  'bas.diff': 'difference {amount}',
  'bas.confirmPaid': 'Confirm payment',
  'bas.confirmedPaid': 'Invoice marked as paid',
}
